import { gql } from '@apollo/client';
import { NSC_PROGRESSION_DATA } from '../../fragments';

export const EXPORT_NSC_PROGRESSION = gql`
  query ExportNSCProgressionData($input: ExportArgs!) {
    exportNSCProgressionData(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      nscProgressionData {
        ...nscProgressionData
      }
    }
  }
  ${NSC_PROGRESSION_DATA}
`;
